var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2028 7.64219L12.7891 4.76328L14.2297 1.09688C14.3264 0.850781 14.2968 0.571094 14.1507 0.351562C14.0045 0.132031 13.7609 0 13.5 0H2.50006C2.06616 0 1.71436 0.357812 1.71436 0.8V15.2C1.71436 15.6422 2.06616 16 2.50007 16C2.93397 16 3.28577 15.6422 3.28577 15.2V8.8H13.5C13.7724 8.8 14.0252 8.65625 14.1683 8.42031C14.3114 8.18438 14.3245 7.88984 14.2028 7.64219Z",
    fill: "#FE7E07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndMark);
export default __webpack_public_path__ + "static/media/end_mark.365b9541ae4b53f67c0a04a9776d3fdb.svg";
export { ForwardRef as ReactComponent };